import { defineMessages } from 'react-intl';

export default defineMessages({
    anErrorOccurred: {
        id: 'wmic-pe-capability-gateway-common-react.wizard.error.cancel',
        defaultMessage: 'Something went wrong during this process.',
    },
    anErrorOccurredTitle: {
        id: 'wmic-pe-capability-gateway-common-react.wizard.error.cancel.title',
        defaultMessage: 'Error',
    },
    saveQuoteError: {
        id: 'wmic-pe-capability-gateway-common-react.wizard.Unable to quote',
        defaultMessage: 'Unable to quote',
    },
    saveQuoteErrorMessage: {
        id: 'wmic-pe-capability-gateway-common-react.wizard.An error occurred while attempting to quote.',
        defaultMessage: 'An error occurred while attempting to quote.',
    },
});
